import { render, staticRenderFns } from "./ProductImagesWidget.vue?vue&type=template&id=1625493f&scoped=true&"
import script from "./ProductImagesWidget.vue?vue&type=script&lang=js&"
export * from "./ProductImagesWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductImagesWidget.vue?vue&type=style&index=0&id=1625493f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1625493f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
